export let Flow;
(function (Flow) {
  Flow["Crm"] = "crm";
  Flow["FbCrm"] = "fb-crm";
  Flow["Marketing"] = "marketing";
  Flow["Integrations"] = "integrations";
  Flow["Academy"] = "academy";
  Flow["Sales"] = "sales";
  Flow["Service"] = "service";
  Flow["ClassroomTraining"] = "classroom-training";
  Flow["Purchase"] = "purchase";
  Flow["AssetProvider"] = "asset-provider";
  Flow["CmsDevelopers"] = "cms-developers";
  Flow["HubspotForStartups"] = "hubspot-for-startups";
  Flow["DirectoryListing"] = "directory-listing";
  Flow["HubSpotPartners"] = "hubspot-partners";
  Flow["Trial"] = "trial";
  Flow["CmsFree"] = "cms-free";
  Flow["AcademyEmbedded"] = "academy-embedded";
  Flow["Microapp"] = "microapp";
  Flow["Commerce"] = "commerce";
  Flow["AeoStandalone"] = "aeo";
  Flow["Mobile"] = "mobile";
})(Flow || (Flow = {}));